import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';

// Third-party
import { useSetAtom } from 'jotai';

import type { SocialInboxType } from '@/components/pages/conversations/SocialInbox/types';

// Types
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Atoms
import { openedMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

export const useSocialInboxNavigation = () => {
    const pathname = usePathname();
    const router = useRouter();
    const setOpenedMessage = useSetAtom(openedMessageAtom);

    const getFilterFromUrl = (): SocialInboxType | null => {
        for (const socialInboxType of Object.keys(SOCIAL_INBOX_META)) {
            if (pathname?.includes(socialInboxType)) {
                return socialInboxType;
            }
        }

        return null;
    };

    const navigateTo = (socialInboxType: SocialInboxType) => {
        const url = SOCIAL_INBOX_META[socialInboxType].url;
        if (url) {
            setOpenedMessage(null);
            router.push(url);
        }
    };

    return {
        navigateTo,
        currentSocialInbox: getFilterFromUrl()
    };
};
